module.exports = __webpack_public_path__ + "static/media/nme.a61c2f21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/nme.svg
// module id = 121
// module chunks = 0